import { Slider } from "./Slider";
import { FaLink } from "react-icons/fa6";

export function CardProject({ project }) {
    return (
        <div className="card py-4 pb-0 mb-4">
            <div className="card__body">
                <div className="card__text">
                    <div className="card__label">
                        <div className="card__label-body d-inline-flex align-items-center py-1 px-4 rounded-pill">
                            <p className="card__label-body__text mb-0">{project.label}</p>
                        </div>
                    </div>
                    <div className="card__text-content">
                        <p className="card__text-content__title mb-1">{project.websiteName}</p>
                        <p className="card__text-content__description mb-1">{project.websiteDescription}</p>
                        {project.websiteURL &&
                            <a className="card__text-content__link" href={project.websiteURL} target="_blank" rel="noreferrer">
                                <FaLink className="me-1" />
                                {project.websiteName}
                            </a>
                        }
                        <div className="card__text-content__slider mt-2">
                            <Slider
                                images={project.imagesProject.sort()}
                                descriptionImages="Imagen de proyecto" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}